export default "__VITE_ASSET__TYg2yub8__"